import { createStore } from "vuex";
import auth from "./auth";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { auth },
});
